export type PcmStream = {
  kind: 'pcm';
  sampleRate: number;
  chunks: AsyncIterable<Uint8Array>;
};

export function createPcmDecoder(context: AudioContext, sampleRate: number) {
  let pending = new Uint8Array(0);
  return {
    decode(bytes: Uint8Array) {
      const input = new Uint8Array(pending.length + bytes.length);
      input.set(pending);
      input.set(bytes, pending.length);
      const length = input.length - (input.length % 2);
      pending = input.slice(length);
      return length ? pcmBuffer(context, input.slice(0, length), sampleRate) : null;
    },
    finish() {
      if (pending.length) throw new Error('tts_pcm_misaligned');
    },
  };
}

export function pcmBuffer(
  context: AudioContext,
  bytes: Uint8Array,
  sampleRate: number,
): AudioBuffer {
  const aligned = bytes.byteLength - (bytes.byteLength % 2);
  const samples = new Int16Array(aligned / 2);
  const view = new DataView(bytes.buffer, bytes.byteOffset, aligned);
  for (let i = 0; i < samples.length; i++) samples[i] = view.getInt16(i * 2, true);
  const buffer = context.createBuffer(1, samples.length, sampleRate);
  const channel = buffer.getChannelData(0);
  for (let i = 0; i < samples.length; i++) channel[i] = samples[i] / 32768;
  return buffer;
}
